import { styled } from "@mui/material/styles";
import { FC, PropsWithChildren } from "react";

const Container = styled("nav")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: "100%",
  position: "relative",
  overflow: "auto",
  padding: theme.spacing(2),
  backgroundColor: theme.palette.secondary[9],
}));

export const PrimaryNavigationContainer: FC<PropsWithChildren> = (props) => {
  const { children } = props;
  return <Container aria-label="Primary">{children}</Container>;
};
